import { render, staticRenderFns } from "./UploadDishPage.vue?vue&type=template&id=5b8a9108&scoped=true&"
import script from "./UploadDishPage.vue?vue&type=script&lang=js&"
export * from "./UploadDishPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a9108",
  null
  
)

export default component.exports